import { Stack } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { MeetingDetailsOrder } from "../../../../../../nonAdminUser/reports/home/meetingServiceApi"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { Organizer } from "../../../../../../../shared/types/OrganizerTypes"
import { getOrganizerPhones } from "../../../../../../../shared/utils/getOrderPerson"

import { getContactInfo } from "../slipModal/utils"
import DetailRow from "./DetailRow"

const useStyles = makeStyles()(() => ({
    contactSection: {
        marginTop: ".5rem",
    },
}))

function getContactLines(contact: Organizer) {
    return [contact.email, ...getOrganizerPhones(contact)]
}

interface ContactDetailsProps {
    order: MeetingDetailsOrder
}

export default function ContactDetails({ order }: ContactDetailsProps) {
    const { classes } = useStyles()

    const { creator, meetingHost, showBoth } = getContactInfo(order.organizers, order.customer)

    return (
        <Stack gap=".5rem" className={classes.contactSection}>
            {showBoth && creator && (
                <LocalizedStrict
                    id="meeting-service-delivery-list-contact-details-meeting-creator"
                    attrs={{ label: true }}
                >
                    <DetailRow label="Creator:" value={creator.name} secondaryValues={getContactLines(creator)} />
                </LocalizedStrict>
            )}
            {meetingHost && (
                <LocalizedStrict
                    id="meeting-service-delivery-list-contact-details-meeting-host"
                    attrs={{ label: true }}
                >
                    <DetailRow
                        label="Meeting host:"
                        value={meetingHost.name}
                        secondaryValues={getContactLines(meetingHost)}
                    />
                </LocalizedStrict>
            )}
        </Stack>
    )
}
